<template>
    <v-btn @click="onClick"
           :disabled="isDisabled"
           ref="show-fullscreen-button"
           content="Full Screen View"
           v-tippy>
        <v-icon class="material-icons">fullscreen</v-icon>
    </v-btn>
</template>

<script>

import { mapState } from "vuex";

export default {
    mounted() {
        this.$root.$refs.showFullscreenButton = this.$refs['show-fullscreen-button']
    },

    computed: {
        ...mapState('Projects', ['image']),
        isDisabled() {
            return !this.image;
        }
    },

    methods: {
        onClick() {
            if (this.isDisabled) return;
            window.UI.enterFullscreen();
        },
    },
};
</script>
